import { ProductGate } from "./ProductGate";

export function VerificationApp() {
  return (
    <ProductGate
      appId="verification"
      linkAppId="ares"
      note="Verification runs are powered by ARES. Connect ARES to inspect proofs, gates, and regression evidence."
    />
  );
}
